// @ts-nocheck
import React, {useState} from 'react';

import { BoxedDiv, BoxedSpan } from 'psims/react/components/layout';
import Button from 'psims/react/components/button';
import { InputNew as Input } from 'psims/react/components/input';
import Divider from 'psims/react/components/divider';
import { UseEditUser } from './use-edit-user';
import Select from 'psims/react/components/select';
import { asString } from 'psims/lib/string';
import Text from 'psims/react/components/text';
import Notification from 'psims/react/components/notification';
import { StatusField, UserAccount } from './shared';
import { H2 } from 'psims/react/components/typography';
import Tick from 'psims/react/components/icons/tick';
import SingleAccordion from 'psims/react/components/accordion/SingleAccordion';
interface EditUserProps {
    ctrl: UseEditUser;
}

const EditUser = (props: EditUserProps) => {
    const vm = useVM(props);
    const [checkedYN, setCheckedYN] = useState<number>(vm.user?.userReportAccesses?.length === 0 ? 0 : vm.user?.userReportAccesses?.length)
    const [checkedReporterYN, setCheckedRepoeterYN] = useState<boolean>(false)
    
    if (vm.user === null) {
        return null;
    }

     const handleChange = (e) => {
        const reportingObligationId:number = Number(e.target.value);
        const hasAccess:boolean = e.target.checked;
       
        if(hasAccess){
                const updatedArray = vm.user?.userReportAccesses?.map(item => {
                if (item.reportingObligationId === reportingObligationId) {
             return { ...item, hasAccess:true };
                }
                 return item; // Return other items as they are
                });
          vm.updateUser('userReportAccesses', updatedArray)
          setCheckedYN(prev => prev + 1)
        }
        else{
                const updatedArray = vm.user?.userReportAccesses?.map(item => {
                if (item.reportingObligationId === reportingObligationId) {
             return { ...item, hasAccess:false };
                }
                 return item; // Return other items as they are
                });      
          vm.updateUser('userReportAccesses', updatedArray)
          setCheckedYN(prev => prev - 1)
        }
        
    }
    const handleSelectAllClick = () =>{
      const allROArray = vm.user?.userReportAccesses?.map(item => {
                 {
             return { ...item, hasAccess:true };
                }
                 
                });
          vm.updateUser('userReportAccesses', allROArray)
                setCheckedYN(allROArray?.length)

    }
    const handleClearAllClick = () =>{
        
        const clearROArray = vm.user?.userReportAccesses?.map(item => {
                 {
             return { ...item, hasAccess:false };
                }
                 
                });
          vm.updateUser('userReportAccesses', clearROArray)
          setCheckedYN(0)
    }

    const editUserCaption = vm.isMyDetails ? 'My details' : 'Edit user account';

    const RoleType = () => {
        if (vm.isMyDetails) {
            return null;
        }

        return (
            <BoxedDiv box={{flex: 'row'}}>
                <Select
                    error={vm.validationMessages.roleType}
                    id='roletypeid'
                    label='Role type'
                    flexGrow={1}
                    forceError={vm.saveAttempted}
                    marginRight={4}
                    placeholder='Select a role type'
                    options={vm.selectRoleCtrl.options}
                    onChange={vm.selectRoleCtrl.onChange}
                    value={vm.selectRoleCtrl.value}
                />

                <BoxedSpan box={{flexGrow: 1, marginLeft: 4}} />

            </BoxedDiv>
        );
    };

    const ReportingObligations = () => {

        return ( <BoxedDiv box={{flex: 'column'}}>
                 {
                                   vm?.user?.userReportAccesses?.sort((a:any, b:any) => a?.reportingOrganisation?.localeCompare(b?.reportingOrganisation))?.map((data, index) => (
                                   data.hasAccess === true && (
                                    <BoxedDiv className='forBox' box={{flex: 'row', marginLeft:1}} key={data.reportingObligationId}>

                                                <BoxedSpan box={{paddingTop: 0.5}}>
                                                    <Tick color='green' size='sm' />
                                                </BoxedSpan>
                                                <BoxedDiv box={{marginLeft: 1}}>
                                                    <Text>{data.reportingOrganisation ? data.reportingOrganisation : reportingOrganisationName} - {data.reportingObligationName}</Text>
                                                </BoxedDiv>
                                       
                                  </BoxedDiv>
                                   )  
                                   ))
                               }
            </BoxedDiv>
        );
    };
     const accordionData = 
    {
      id: 1,
      title: 'My Reporting Obligations',
      content: 'NA',
    }

    return (
        <BoxedDiv box={{flex: 'column'}}>
            <H2>{editUserCaption}</H2>

            <UserAccount
                updateUser={vm.updateUser}
                user={vm.user}
                isMyDetails={vm.isMyDetails}
                validationMessages={vm.validationMessages}
            />            

            <BoxedDiv box={{flex: 'row'}}>
                <Input
                    id='firstname'
                    autoFocus={vm.isMyDetails}
                    error={vm.validationMessages.firstName}
                    label='First name'
                    flexGrow={1}
                    marginRight={4}
                    onChange={e => vm.updateUser('firstName', e.target.value)}
                    value={asString(vm.user?.firstName)}
                />

                <Input
                    id='surname'
                    error={vm.validationMessages.lastName}
                    label='Surname'
                    flexGrow={1}
                    marginLeft={4}
                    onChange={e => vm.updateUser('lastName', e.target.value)}
                    value={asString(vm.user?.lastName)}
                />
            </BoxedDiv>

           <RoleType /> 
           
           {vm.isMyDetails === true ? (
            <BoxedDiv box={{flex: 'column', marginBottom:4 }}>
                     <BoxedDiv box={{flex: 'column', marginBottom:2 }}>
                    <label className='sc-fqkvVR Llmmz text'>Reporting Obligations</label>
                    </BoxedDiv>
                    <SingleAccordion items={accordionData}>
                        <ReportingObligations />
                    </SingleAccordion> 
                      
            </BoxedDiv>
            )
            : (
                <BoxedDiv box={{flex: 'column'}}  >
                               <label className='labelclass'>Select Reporting Obligation</label>
                               {(checkedYN === 0 && vm.user?.roleTypeId === 2) && <label role='alert' className="sc-eldPxv eEjepK alertclass">{"Please select atleast one reporting obligation"}</label>}
                                   {
                                   vm?.user?.userReportAccesses?.sort((a:any, b:any) => a?.reportingOrganisation?.localeCompare(b?.reportingOrganisation))?.map((data, index) => (
                                       <BoxedDiv className='forBox' box={{flex: 'row'}} key={data.reportingObligationId}>
                                   <input
                                       name= "ReportingObligation"
                                       className='checkboxClass'
                                       id={data.reportingObligationId?.toString()}
                                       type="checkbox"                            
                                       key={data.reportingObligationId} 
                                       //checked={ vm.user?.roleTypeId === 1 ? true : data.hasAccess }
                                       checked={ data.hasAccess }
                                       value={data.reportingObligationId} 
                                       onChange={(e) => handleChange(e)} 
                                       aria-label={data.reportingObligationName}
                                       disabled={vm.user?.roleTypeId === 1 ? true : vm.isMyDetails ? true : false}
                                       
                                   />
                                   <label 
                                   htmlFor="ReportingObligation"
                                   >{data.reportingOrganisation ? data.reportingOrganisation : reportingOrganisationName} - {data.reportingObligationName}</label>
                                    </BoxedDiv>
                                   ))
                               }
                             
                         {(vm.user?.roleTypeId === 2 )&& 
                         (<>
                            <BoxedDiv box={{flexGrow: 1, marginLeft: 4, marginBottom: 4}} />
                             <BoxedDiv box={{flex: 'row'}}>
                            <Button $kind={'primary'} $size='sm' marginRight={6} onClick={handleSelectAllClick}>Select All</Button>
                            <Button $kind={'text'} $size='sm' onClick={handleClearAllClick}>Clear All</Button>
                            </BoxedDiv>
                         </>)}
                    </BoxedDiv>
            )}

            <StatusField status={vm.user.status} />

            {
                vm.user?.status === 'Registered' &&
                <>
                    <BoxedDiv box={{marginBottom: 2, marginTop: 2}}>
                        <h3>Contact details</h3>
                    </BoxedDiv>

                    <Input
                        error={vm.validationMessages.phoneNumber}
                        id='phone'
                        label='Phone number'
                        onChange={e => vm.updateUser('phoneNumber', e.target.value)}
                        value={asString(vm.user.phoneNumber)}
                    />

                    <BoxedDiv box={{marginBottom: 2, marginTop: 2}}>
                        <h3>Contact address</h3>
                    </BoxedDiv>

                    <Text variant='help'>This is the Australian address where mail correspondence could be sent to you</Text>

                    <Input
                        error={vm.validationMessages.addressLine1}
                        id='addressline1'
                        label='Address line 1'
                        onChange={e => vm.updateUser('addressLine1', e.target.value)}
                        value={asString(vm.user.addressLine1)}
                    />

                    <Input
                        error={vm.validationMessages.addressLine2}
                        id='addressline2'
                        label='Address line 2 (optional)'
                        onChange={e => vm.updateUser('addressLine2', e.target.value)}
                        value={asString(vm.user.addressLine2)}
                    />

                    <BoxedDiv box={{flex: 'row'}}>
                        <Input
                            error={vm.validationMessages.city}
                            flexGrow={3}
                            id='suburb'
                            label='Suburb'
                            marginRight={3}
                            onChange={e => vm.updateUser('city', e.target.value)}
                            value={asString(vm.user.city)}
                        />

                        <Select
                            error={vm.validationMessages.stateId}
                            id='state'
                            label='State'
                            flexGrow={1}
                            marginLeft={3}
                            marginRight={3}
                            placeholder='Select'
                            options={vm.selectStateCtrl.options}
                            onChange={vm.selectStateCtrl.onChange}
                            value={vm.selectStateCtrl.value}
                        />

                        <Input
                            error={vm.validationMessages.postcode}
                            flexGrow={1}
                            id='postcode'
                            label='Postcode'
                            marginLeft={3}
                            onChange={e => vm.updateUser('postcode', e.target.value)}
                            value={asString(vm.user.postcode)}
                        />
                    </BoxedDiv>
                </>
            }

            <BoxedDiv box={{marginTop: 5}}>
                <Divider />
            </BoxedDiv>

            {
                vm.serviceError &&

                <BoxedDiv box={{marginV: 1}}>
                    <Notification align='center' kind='warning'>
                        {vm.serviceError}
                    </Notification>
                </BoxedDiv>
            }


            <BoxedDiv box={{flex: 'row-reverse', justifyContent: 'flex-start', marginTop: 3.5}}>
                <Button
                    disabled={vm.serviceStatus === 'loading'}
                    $kind='primary'
                    marginLeft={6}
                    onClick={vm.save}
                    state={vm.serviceStatus === 'loading' ? 'loading' : 'normal'}
                    disabled={(checkedYN === 0 && vm.selectRoleCtrl.value?.value === 2) ? true : false}
                >Save</Button>

                <Button $kind='text' onClick={vm.cancel}>Cancel</Button>
            </BoxedDiv>
        </BoxedDiv>
    )
}

function useVM({ctrl: {user, cancel, isMyDetails, roleOptions, save, saveAttempted, selectRoleCtrl, selectStateCtrl, stateOptions, serviceError, serviceStatus, statusOptions, updateUser, validationMessages}}: EditUserProps) {
    return {
        cancel,
        isMyDetails,
        roleOptions,
        save,
        saveAttempted,
        selectRoleCtrl,
        selectStateCtrl,
        serviceError,
        serviceStatus,
        stateOptions,
        statusOptions,
        updateUser,
        user,
        validationMessages,
    };
}


export default EditUser;
